// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"4159a03c","139":"a02feea1","950":"6808a7e7"}[chunkId] + ".chunk.js";
};